import { useTranslation } from "react-i18next";

export default function Breadcrumb() {
  const { t } = useTranslation("slotenmaker-eindhoven");

  return (
    <nav aria-label="Breadcrumb" className="bg-brand-cream border-b border-brand-border">
      <div className="max-w-[1440px] mx-auto px-4 md:px-10 py-3 md:py-4">
        <ol className="flex items-center gap-2 font-geist text-sm text-brand-text/60">
          <li>
            <a href="/" className="hover:text-brand-blue transition-colors">
              {t("breadcrumb.home")}
            </a>
          </li>
          <li>
            <i className="ri-arrow-right-s-line w-4 h-4 flex items-center justify-center text-brand-text/30"></i>
          </li>
          <li className="text-brand-text font-medium" aria-current="page">
            {t("breadcrumb.current")}
          </li>
        </ol>
      </div>
    </nav>
  );
}